import store from '../../store'
import { fetchConfiguration } from '../../actions/configuration'

// default to 10 minutes if not set or invalid
const interval = parseInt(process.env.REACT_APP_CONFIGURATION_POLLING_INTERVAL_IN_MS, 10) || 600000

let intervalId = null

export function startConfigurationPolling() {
  // initial fetch
  store.dispatch(fetchConfiguration())

  // background polling
  intervalId = setInterval(() => {
    store.dispatch(fetchConfiguration())
  }, interval)
}

export function stopConfigurationPolling() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}
